import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import Footer from "../components/Footer/Footer";

const styles = theme => ({});

const Support = () => {
  return (
    <Main>
      <Article>
        <PageHeader title="Support the site" />
        <Content>
          I buy all these helmets, and spend hours researching and testing - please consider
          supporting PSH by participating in the following options:
          <br />
          <br />
          -{" "}
          <a href="https://www.buymeacoffee.com/surfhelmet" target="_blank">
            Buying me a coffee
          </a>
          <br />
          <br />
          - Clicking on links to products. Although these are independent reviews, when you buy
          through my links, I may earn a commission from the retailer that sells the product. Please
          understand, there’s no incentive to pick inferior products or to respond to pressure from
          manufacturers - in fact, it’s quite the opposite. If a reader returns their purchase, I
          earn no affiliate commission.
          <br />
          <br />
          <br />
          <br />
        </Content>
        {/*<Form />*/}
      </Article>
      <Footer />
    </Main>
  );
};

Support.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Support);



// WEBPACK FOOTER //
// ./src/pages/support.js